<h1 mat-dialog-title>{{ 'SAVE-CHANGES-DIALOG.SAVE-CHANGES' | translate }}</h1>
<div mat-dialog-content>
    <p>{{ 'SAVE-CHANGES-DIALOG.INFO' | translate }}</p>
</div>
<div mat-dialog-actions>
    <button class="save-changes-field-btn" mat-flat-button (click)="saveChanges()">{{ 'DELETE-ALL-PINS-DIALOG.YES' | translate }}</button>
    <button class="save-changes-field-btn" mat-flat-button (click)="cancel()">{{ 'DELETE-ALL-PINS-DIALOG.NO' | translate }}</button>
</div>
